// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UPZvA","label":"SetPasswdForm_label__1FOoZ"};